document.addEventListener("DOMContentLoaded", async () => {
  const urlParts = window.location.href.split("/");
  const lastPart =
    urlParts[urlParts.length - 1] || urlParts[urlParts.length - 2];

  // Escape API-sourced text before injecting it into HTML strings.
  // Canonical helper lives in snippets/global-variables.liquid; local
  // fallback kept in case this script loads without it.
  const escapeHtml =
    window.aicoEscapeHtml ||
    function (v) {
      return String(v ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    };

  function convertDate(d) {
    let date = new Date(d);
    const formattedDateTime = date.toLocaleString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    return formattedDateTime; // Formats to DD.MM.YYYY
  }

  function convertDateForGlobalfunction(inputDate) {
    const date = new Date(inputDate);

    // Format the date
    const formattedDate =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0") +
      " " +
      String(date.getHours()).padStart(2, "0") +
      ":" +
      String(date.getMinutes()).padStart(2, "0") +
      ":" +
      String(date.getSeconds()).padStart(2, "0");

    return formattedDate;
  }

  function fetchSocialMediaPostsOg(size, page, source = "YOUTUBE") {
    let header_options = {
      method: "GET",
      headers: {
        Authorization: Authorization,
        Accept: "application/vnd.api+json",
      },
    };

    let top_url = `${API_URL}social-media-posts?sort=-publishedAt&page[number]=${page}&page[size]=${size}&filter[source]=${source}`;
    let res = fetch(top_url, API_Header_Options).then((res) => res.json());

    return res;
  }

  function fetchSocialMediaPostSingle(id) {
    let header_options = {
      method: "GET",
      headers: {
        Authorization: Authorization,
        Accept: "application/vnd.api+json",
      },
    };

    let top_url = `${API_URL}social-media-posts/${id}`;
    let res = fetch(top_url, API_Header_Options).then((res) => res.json());

    return res;
  }

  function generateSlideOg(res, slidePos = "top") {
    let html = "";
    resData = res.data;
    resData.forEach((data) => {
      let { id } = data;
      if (id === lastPart) return;
      let { videoUrl, imageUrl, webThumbnailUrl, mobileThumbnailUrl, title, description, publishedAt } = data.attributes[0];

      if(imageUrl == null || imageUrl == ''){
        imageUrl = defaultPlaceHolder
      }

      if(webThumbnailUrl == null || webThumbnailUrl == ''){
        webThumbnailUrl = imageUrl;
      }

      if(mobileThumbnailUrl == null || mobileThumbnailUrl == ''){
        mobileThumbnailUrl = imageUrl;
      }

      let svgPlay = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
          <defs>
            <clipPath id="clip-path">
              <rect id="Rectangle_1087" data-name="Rectangle 1087" width="100" height="100" transform="translate(-0.364 -0.103)" fill="#fff" />
            </clipPath>
          </defs>
          <g id="Group_1040" data-name="Group 1040" transform="translate(3 27.084)">
            <g id="Group_910" data-name="Group 910" transform="translate(-2.636 -26.981)" clip-path="url(#clip-path)">
              <path id="Path_643" data-name="Path 643" d="M49.666,0A49.984,49.984,0,1,0,99.332,49.983,49.882,49.882,0,0,0,49.666,0m0,94.308A44.326,44.326,0,1,1,93.709,49.983,44.235,44.235,0,0,1,49.666,94.308" transform="translate(-0.03 0.026)" fill="#fff" />
              <path id="Path_644" data-name="Path 644" d="M80.923,48.875,34.069,25.3a2.8,2.8,0,0,0-2.735.125A2.83,2.83,0,0,0,30,27.828V74.983a2.833,2.833,0,0,0,1.333,2.407,2.8,2.8,0,0,0,2.735.124L80.923,53.937a2.839,2.839,0,0,0,0-5.062m-45.3,21.531v-38l37.757,19Z" transform="translate(-1.917 -1.397)" fill="#fff" />
            </g>
          </g>
        </svg>`;

      let slide = `<div class="collage__item swiper-slide collage__item--marq_slider animate">
          <div class="collage-card card-video product-card-wrapper color-scheme-2 gradient">
            <div class="deferred-media--outer">
              <div class="deferred-media">
                <a href="${videoPageURL}/${id}" class="deferred-media__poster full-unstyled-link" aria-label="Video laden: ${escapeHtml(title)}">
                  <div class="media media--transparent ratio" style="--ratio-percent: 56.22065727699531%">
                    <img src="${escapeHtml(webThumbnailUrl)}" alt="${escapeHtml(title)}" class="small-hide web-thumbnail-url">
                    <img src="${escapeHtml(mobileThumbnailUrl)}" alt="${escapeHtml(title)}" class="medium-hide large-up-hide mobile-thumbnail-url">
                    <div class="video-heading h3">
                      ${escapeHtml(title)}
                    </div>
                  </div>
                  <div class="button_wrap button_link">
                    <div class="button button--primary">
                      Abspielen
                    </div>
                    <span class="deferred-media__poster-button motion-reduce">
                      ${svgPlay}
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>`;

      html += slide;
    });
    return html;
  }

  const curretPost = await fetchSocialMediaPostSingle(lastPart);
  //console.log("curretPost", curretPost);
  // if we have data
  if(curretPost.data){
      let { videoUrl, imageUrl, title, description, publishedAt } =
        curretPost.data.attributes[0];

      if(title){        
        title = unicodeToNormal(title);
      }
      const ytId = videoUrl.split("v=")[1];
      const ytUrl = `https://www.youtube.com/embed/${ytId}?enablejsapi=1&autoplay=0&mute=0&rel=0&controls=0&modestbranding=1&playsinline=1&iv_load_policy=3&disablekb=1&showinfo=0`;

      // YouTube IFrame API only after marketing consent (H27 #7)
      if (window.fcrjLoadYtApi) window.fcrjLoadYtApi();

      const iframe = document.createElement("iframe");
      // src only with marketing consent (H27 #7); the head helper sets it on consent
      if (!window.fcrjYtSrc || window.fcrjMarketingOk) iframe.setAttribute("src", ytUrl);
      else iframe.setAttribute("data-fcrj-consent-src", ytUrl);
      iframe.setAttribute("id", "youtube-video-iframe");
      iframe.setAttribute("class", "youtube-video-iframe");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allow", "autoplay; encrypted-media; fullscreen");
      iframe.setAttribute("allowfullscreen", "true");

      document.getElementById("page_video_wrapper").appendChild(iframe);
      document.querySelector(".post-title").textContent = title;
      document.querySelector(".post-description").textContent = description;
      document.querySelector(".post-start-time").textContent = formatDate(
        convertDateForGlobalfunction(publishedAt)
      );

  }


  // Custom player controls
  const controls = document.querySelector(".custom-player-controls");
  const playPauseBtn = document.querySelector(".cp-play-pause");
  const iconPlay = document.querySelector(".cp-icon-play");
  const iconPause = document.querySelector(".cp-icon-pause");
  const progressWrap = document.querySelector(".cp-progress-wrap");
  const progressPlayed = document.querySelector(".cp-progress-played");
  const progressBuffered = document.querySelector(".cp-progress-buffered");
  const timeCurrent = document.querySelector(".cp-time-current");
  const timeDuration = document.querySelector(".cp-time-duration");
  const volumeBtn = document.querySelector(".cp-volume-btn");
  const iconVolume = document.querySelector(".cp-icon-volume");
  const iconMute = document.querySelector(".cp-icon-mute");
  const volumeSlider = document.querySelector(".cp-volume-slider");
  const fullscreenBtn = document.querySelector(".cp-fullscreen");
  const iconFullscreen = document.querySelector(".cp-icon-fullscreen");
  const iconExitFullscreen = document.querySelector(".cp-icon-exit-fullscreen");
  const videoWrapper = document.querySelector(".page-video-wrapper");
  const overlay = document.querySelector(".page-video--overlay");

  let player;
  let progressInterval = null;
  let isSeeking = false;

  function formatTime(seconds) {
    if (isNaN(seconds) || seconds < 0) return "0:00";
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return m + ":" + (s < 10 ? "0" : "") + s;
  }

  function updateProgress() {
    if (!player || !player.getDuration || isSeeking) return;
    const duration = player.getDuration();
    const current = player.getCurrentTime();
    if (duration > 0) {
      progressPlayed.style.width = (current / duration * 100) + "%";
      timeCurrent.textContent = formatTime(current);
      timeDuration.textContent = formatTime(duration);
    }
    // Update buffered
    const fraction = player.getVideoLoadedFraction();
    if (fraction) {
      progressBuffered.style.width = (fraction * 100) + "%";
    }
  }

  function startProgressLoop() {
    if (progressInterval) return;
    progressInterval = setInterval(updateProgress, 250);
  }

  function stopProgressLoop() {
    clearInterval(progressInterval);
    progressInterval = null;
  }

  let hasPlayedOnce = false;

  function setPlayingState(isPlaying) {
    iconPlay.style.display = isPlaying ? "none" : "block";
    iconPause.style.display = isPlaying ? "block" : "none";
    overlay.classList.toggle("hidden", isPlaying);
    if (isPlaying) {
      if (!hasPlayedOnce) {
        hasPlayedOnce = true;
        overlay.classList.add("has-played");
      }
      startProgressLoop();
    } else {
      stopProgressLoop();
      updateProgress();
    }
  }

  window.onYouTubePlayerAPIReady = function () {
    player = new YT.Player("youtube-video-iframe", {
      events: {
        onReady: function () {
          timeDuration.textContent = formatTime(player.getDuration());
          volumeSlider.value = player.getVolume();
        },
        onStateChange: function (e) {
          // YT.PlayerState: PLAYING=1, PAUSED=2, ENDED=0, BUFFERING=3
          if (e.data === 1) {
            setPlayingState(true);
          } else if (e.data === 2 || e.data === 0) {
            setPlayingState(false);
          }
          if (e.data === 0) {
            // Reset on end
            progressPlayed.style.width = "0%";
            timeCurrent.textContent = "0:00";
          }
        },
      },
    });
  }

  // Play/Pause
  playPauseBtn.addEventListener("click", function () {
    if (!player || !player.getPlayerState) return;
    const state = player.getPlayerState();
    if (state === 1) {
      player.pauseVideo();
    } else {
      player.playVideo();
    }
  });

  // Overlay play button
  document.querySelector(".player-play-btn").addEventListener("click", function () {
    if (player && player.playVideo) player.playVideo();
  });

  // Click on video area to toggle play/pause
  videoWrapper.addEventListener("click", function (e) {
    if (e.target.closest(".custom-player-controls") || e.target.closest(".page-video--overlay")) return;
    if (!player || !player.getPlayerState) return;
    const state = player.getPlayerState();
    if (state === 1) {
      player.pauseVideo();
    } else {
      player.playVideo();
    }
  });

  // Progress bar seek
  progressWrap.addEventListener("mousedown", function (e) {
    isSeeking = true;
    seek(e);
    document.addEventListener("mousemove", seek);
    document.addEventListener("mouseup", function handler() {
      isSeeking = false;
      document.removeEventListener("mousemove", seek);
      document.removeEventListener("mouseup", handler);
    });
  });

  progressWrap.addEventListener("touchstart", function (e) {
    isSeeking = true;
    seekTouch(e);
    document.addEventListener("touchmove", seekTouch);
    document.addEventListener("touchend", function handler() {
      isSeeking = false;
      document.removeEventListener("touchmove", seekTouch);
      document.removeEventListener("touchend", handler);
    });
  }, { passive: true });

  function seek(e) {
    if (!player || !player.getDuration) return;
    const rect = progressWrap.getBoundingClientRect();
    const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    const duration = player.getDuration();
    player.seekTo(pct * duration, true);
    progressPlayed.style.width = (pct * 100) + "%";
    timeCurrent.textContent = formatTime(pct * duration);
  }

  function seekTouch(e) {
    if (e.touches && e.touches.length > 0) {
      seek(e.touches[0]);
    }
  }

  // Volume
  volumeBtn.addEventListener("click", function () {
    if (!player || !player.isMuted) return;
    if (player.isMuted()) {
      player.unMute();
      volumeSlider.value = player.getVolume() || 100;
      iconVolume.style.display = "block";
      iconMute.style.display = "none";
    } else {
      player.mute();
      volumeSlider.value = 0;
      iconVolume.style.display = "none";
      iconMute.style.display = "block";
    }
  });

  volumeSlider.addEventListener("input", function () {
    if (!player || !player.setVolume) return;
    const val = parseInt(this.value);
    player.setVolume(val);
    if (val === 0) {
      player.mute();
      iconVolume.style.display = "none";
      iconMute.style.display = "block";
    } else {
      player.unMute();
      iconVolume.style.display = "block";
      iconMute.style.display = "none";
    }
  });

  // Fullscreen
  fullscreenBtn.addEventListener("click", function () {
    if (!document.fullscreenElement) {
      videoWrapper.requestFullscreen().then(function () {
        iconFullscreen.style.display = "none";
        iconExitFullscreen.style.display = "block";
      }).catch(function () {});
    } else {
      document.exitFullscreen();
      iconFullscreen.style.display = "block";
      iconExitFullscreen.style.display = "none";
    }
  });

  document.addEventListener("fullscreenchange", function () {
    if (!document.fullscreenElement) {
      iconFullscreen.style.display = "block";
      iconExitFullscreen.style.display = "none";
    }
  });

  // Auto-hide controls on inactivity
  let hideTimeout;
  function showControls() {
    controls.classList.add("cp-visible");
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(function () {
      if (player && player.getPlayerState && player.getPlayerState() === 1) {
        controls.classList.remove("cp-visible");
      }
    }, 3000);
  }
  videoWrapper.addEventListener("mousemove", showControls);
  videoWrapper.addEventListener("mouseenter", showControls);
  videoWrapper.addEventListener("mouseleave", function () {
    if (player && player.getPlayerState && player.getPlayerState() === 1) {
      controls.classList.remove("cp-visible");
    }
  });
  videoWrapper.addEventListener("touchstart", showControls, { passive: true });

  const allPosts = await fetchSocialMediaPostsOg(20, 1);

  // console.log("📃 allPosts", allPosts);

  const slideBottomHtml = await generateSlideOg(allPosts, "bottom");
  document.querySelector(".swiper-wrapper").innerHTML = slideBottomHtml;

  if(slideBottomHtml != ''){
    $('.section-video_tv').removeClass('hidden');
  }

  let topSlickSlider = $(
    ".section-video_tv .swiper-wrapper:not(.slick-initialized)"
  ).slick({
    infinite: false,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    swipeToSlide: true,
    slidesToShow: 3.3,
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: 2.5 },
      },
      {
        breakpoint: 750,
        settings: { slidesToShow: 2.2 },
      },
      {
        breakpoint: 577,
        settings: { slidesToShow: 1.1 },
      }
    ],
  });
});
